// src/data/statePublishedHardness.js — GENERATED by scripts/build-water-rankings.mjs (s136, DECISIONS #58).
// Do not hand-edit. Rebuild: npm run build-rankings. Gate: verify-water-rankings (E).
// Per state: lo/hi lowest/highest hardness (mg/L as CaCO3) the state's covered utilities publish,
// med median of their ranking keys, n cities with a published figure, of cities covered.
// n 0 = no covered utility publishes a figure: show the planning range and label it PLANNING.
export const STATE_PUBLISHED_HARDNESS = {"alabama":{"lo":4,"hi":156,"med":71,"n":4,"of":5},
"alaska":{"lo":82,"hi":210,"med":142,"n":3,"of":5},
"arizona":{"lo":158,"hi":376,"med":252,"n":4,"of":6},
"arkansas":{"lo":74,"hi":74,"med":74,"n":2,"of":5},
"california":{"lo":8.1,"hi":440,"med":157,"n":6,"of":6},
"colorado":{"lo":34,"hi":198,"med":77,"n":3,"of":5},
"connecticut":{"lo":34,"hi":86,"med":51,"n":2,"of":5},
"delaware":{"lo":23,"hi":228,"med":75,"n":3,"of":5},
"florida":{"lo":120,"hi":341,"med":172,"n":4,"of":6},
"georgia":{"lo":31.2,"hi":33.4,"med":32,"n":1,"of":6},
"hawaii":{"n":0,"of":5},
"idaho":{"lo":0,"hi":240,"med":119,"n":3,"of":5},
"illinois":{"lo":80,"hi":160,"med":135,"n":3,"of":6},
"indiana":{"lo":50,"hi":633,"med":140,"n":7,"of":8},
"iowa":{"lo":50,"hi":550,"med":184,"n":4,"of":5},
"kansas":{"lo":144,"hi":300,"med":154,"n":5,"of":5},
"kentucky":{"lo":88,"hi":161,"med":139,"n":4,"of":5},
"louisiana":{"lo":23.5,"hi":79.9,"med":52,"n":2,"of":5},
"maine":{"lo":5.3,"hi":17,"med":7,"n":5,"of":5},
"maryland":{"lo":58,"hi":213,"med":136,"n":3,"of":5},
"massachusetts":{"lo":10,"hi":55,"med":12,"n":3,"of":6},
"michigan":{"lo":74,"hi":180,"med":107,"n":5,"of":6},
"minnesota":{"lo":44,"hi":283,"med":91,"n":5,"of":5},
"mississippi":{"n":0,"of":5},
"missouri":{"lo":74,"hi":206,"med":129,"n":5,"of":5},
"montana":{"lo":52,"hi":233,"med":143,"n":3,"of":5},
"nebraska":{"lo":170,"hi":377,"med":181,"n":4,"of":5},
"nevada":{"lo":32,"hi":304,"med":280,"n":5,"of":5},
"new-hampshire":{"lo":9,"hi":204,"med":21,"n":3,"of":5},
"new-jersey":{"lo":52.6,"hi":222,"med":93,"n":6,"of":6},
"new-mexico":{"lo":43,"hi":230,"med":151,"n":1,"of":5},
"new-york":{"lo":22,"hi":127,"med":82,"n":6,"of":6},
"north-carolina":{"lo":5.52,"hi":62,"med":28,"n":7,"of":7},
"north-dakota":{"lo":100,"hi":150,"med":123,"n":4,"of":5},
"ohio":{"lo":76,"hi":155,"med":120,"n":5,"of":6},
"oklahoma":{"lo":89,"hi":140,"med":115,"n":1,"of":5},
"oregon":{"lo":7,"hi":68,"med":21,"n":3,"of":5},
"pennsylvania":{"lo":90,"hi":284,"med":161,"n":3,"of":6},
"rhode-island":{"n":0,"of":5},
"south-carolina":{"lo":18,"hi":56,"med":46,"n":4,"of":5},
"south-dakota":{"lo":168,"hi":250,"med":209,"n":1,"of":5},
"tennessee":{"lo":12,"hi":132,"med":78,"n":5,"of":5},
"texas":{"lo":44,"hi":342,"med":136,"n":5,"of":6},
"utah":{"lo":16,"hi":602,"med":214,"n":5,"of":5},
"vermont":{"lo":60,"hi":64,"med":60,"n":4,"of":5},
"virginia":{"lo":32,"hi":191,"med":69,"n":8,"of":8},
"washington":{"lo":17,"hi":360,"med":28,"n":6,"of":6},
"west-virginia":{"lo":17,"hi":154,"med":105,"n":3,"of":5},
"wisconsin":{"lo":112,"hi":342,"med":140,"n":5,"of":5},
"wyoming":{"lo":46,"hi":496,"med":232,"n":2,"of":5}};
